<template>
  <UiBaseIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    class="icon"
  >
    <path
      d="M5.776 6.614a.417.417 0 0 1 .687-.152l7.074 7.074a.417.417 0 0 1-.152.687L3 17.999l-1-1L5.776 6.614Zm-1.422 9.03 6.465-2.351-4.114-4.114-2.351 6.466Zm13.886-3.802-3.5 1-.48-1.684 3.5-1 .48 1.684Zm.32-7.17-6 5-1.12-1.344 6-5 1.12 1.344ZM9.843 2.24l-1 3.5-1.684-.48 1-3.5 1.684.48Zm4.408.71-1.5 2.5-1.5-.9 1.5-2.5 1.5.9Z"
      fill="currentColor"
    />
  </UiBaseIcon>
</template>

<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';
</script>
